import { Component } from "@angular/core";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Observable } from "rxjs";
import { DatabaseFilterParams } from "../common/common.model";
import { DatabaserListesideBaseClass } from "../common/listeside/databaser.listeside.component";
import { DatabaserService } from "../database/database.service";
import { TilgangService } from "../services/tilgang.service";


@Component({
  selector: "app-databaser",
  templateUrl: "./databaser.component.html"
})
export class DatabaserComponent extends DatabaserListesideBaseClass {

  overskrift = "Oversikt over Databaser";

  constructor(
    private service: DatabaserService,
    tilgangService: TilgangService, route: ActivatedRoute, router: Router
  ) { super(route, router, tilgangService); }


  search(params: DatabaseFilterParams): Observable<any> {
    return this.service.search(params.tekst, params.order, params.pageNumber, params.pageSize, params.types, params.hasSystem);
  }
  
}
